import { Component, computed, inject, signal } from '@angular/core';
import { DesignSystemModule } from '@sanopass-frontend/design-system';
import { ToastService } from './service';

const ANIMATION_MS = 250;

@Component({
  standalone: true,
  imports: [DesignSystemModule],
  selector: 'app-toast',
  templateUrl: './component.html',
  styleUrl: './component.scss',
})
export class ToastComponent {
  private readonly toast = inject(ToastService);
  readonly toasts = computed(() => this.toast.toasts());

  private readonly leaving = signal<Record<string, true>>({});

  isLeaving = (id: string) => !!this.leaving()[id];

  dismiss(id: string) {
    if (this.isLeaving(id)) return;

    this.leaving.update((m) => ({ ...m, [id]: true }));

    setTimeout(() => {
      this.toast.dismiss(id);
      this.leaving.update((m) => {
        const rest = { ...m };
        delete rest[id];
        return rest;
      });
    }, ANIMATION_MS);
  }
}
